import { makeVar } from '@apollo/client';
import { PersistedStateKeys } from 'shared/enums/PersistedStateKeys';

/**
 * Get the default persisted userAppointmentGroupingsFilters
 */
const getUserAppointmentGroupingsDefaultFilters = (): Record<string, string[]> => {
  const result = localStorage.getItem(PersistedStateKeys.UserAppointmentGroupingsFilter);
  return result && result !== 'null' ? JSON.parse(result) : {};
};

/**
 * Record<clinicId, userAppointmentGroupingId>
 */
const userAppointmentGroupingsFilters = makeVar<Record<string, string[]>>(getUserAppointmentGroupingsDefaultFilters());

/**
 * Get the persisted userAppointmentGroupingsFilters from the reactive var
 */
export const getPersistedUserAppointmentGroupingsFilters = (): Record<string, string[]> => {
  return userAppointmentGroupingsFilters();
};

/**
 * Set the userAppointmentGroupingsFilters in local storage as well as in the reactiveVar
 * @param data Record<string, string[]>
 */
export const setPersistedUserAppointmentGroupingsFilters = (data: Record<string, string[]>): void => {
  localStorage.setItem(PersistedStateKeys.UserAppointmentGroupingsFilter, JSON.stringify(data));
  userAppointmentGroupingsFilters(data);
};
